import type * as React from 'react'

import {
  Tooltip,
  Button,
  Text,
  DropdownMenu,
  IconButton,
  EllipsisVerticalIcon,
  TrashIcon,
  PencilIcon,
  Flex,
  Separator,
  Heading,
} from '@buffer-mono/popcorn'

import type { HashtagGroup } from '../../types'

import styles from './HashtagGroupItem.module.css'

interface HashtagGroupItemProps {
  onInsertHashtagGroupClick: () => void
  onEditHashtagGroupClick: (group: HashtagGroup) => void
  onDeleteHashtagGroupClick: (group: HashtagGroup) => void
  numberOfHashtags: number
  group: HashtagGroup
}

function HashtagGroupItem({
  numberOfHashtags,
  group,
  onInsertHashtagGroupClick,
  onEditHashtagGroupClick,
  onDeleteHashtagGroupClick,
}: HashtagGroupItemProps): React.ReactElement {
  return (
    <>
      <Flex justify="between" align="center" className={styles.item}>
        <Tooltip content={group.text} side="top">
          <Flex direction="column">
            <Flex align="center" gap="xs">
              <Heading as="p" size="small">
                {group.name}
              </Heading>
              <Text color="subtle">{numberOfHashtags}</Text>
            </Flex>
            <Text color="subtle" className={styles.text}>
              {group.text}
            </Text>
          </Flex>
        </Tooltip>
        <Flex gap="xs" align="center" className={styles.actions}>
          <Button onClick={onInsertHashtagGroupClick}>Insert</Button>
          <DropdownMenu>
            <DropdownMenu.Trigger>
              <IconButton label="More options" variant="tertiary">
                <EllipsisVerticalIcon />
              </IconButton>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content align="end">
              <DropdownMenu.Item onClick={() => onEditHashtagGroupClick(group)}>
                <PencilIcon color="subtle" />
                Edit Group
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => onDeleteHashtagGroupClick(group)}
                variant="critical"
              >
                <TrashIcon color="critical" />
                Delete Group
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu>
        </Flex>
      </Flex>
      <Separator style={{ '--separator-gutter': '0' } as React.CSSProperties} />
    </>
  )
}

export default HashtagGroupItem
